import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

function baseStyle(props: StyleFunctionProps) {
  return {
    bg: mode('blackAlpha.900', 'whiteAlpha.900')(props),
    color: mode('white', 'gray.900')(props),
    fontSize: 'xs',
    rounded: 'md',
    fontWeight: 'normal',
    borderColor: mode('whiteAlpha.300', 'blackAlpha.200')(props),
    borderWidth: 'thin',
    textAlign: 'center',
    boxShadow: 'xs',
  };
}

export default {
  baseStyle,
};
